import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=a7553afc&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.scss?vue&type=style&index=0&id=a7553afc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7553afc",
  null
  
)

export default component.exports